import Glide from '@glidejs/glide'
var $ = jQuery;

export default class PostSlider {
    constructor(app) {
        this.SLIDER_CONTAINERS = document.querySelectorAll('.post-slider');

        this.init();
    }

    init() {
        if(this.SLIDER_CONTAINERS){
            for (let i = 0; i < this.SLIDER_CONTAINERS.length; i++) {
                const SLIDER_CONTAINER = this.SLIDER_CONTAINERS[i];
                const ARROW_LEFT = SLIDER_CONTAINER.querySelector('.arrow-left');
                const ARROW_RIGHT = SLIDER_CONTAINER.querySelector('.arrow-right');
                const SLIDES = SLIDER_CONTAINER.querySelectorAll('.posts .glide__slide').length;
                const PER_VIEW = SLIDER_CONTAINER.querySelector('.posts').getAttribute('per-view');
                const CONTROLS = SLIDER_CONTAINER.querySelector('.controls');

                if(SLIDES > 0){

                    let slider = new Glide(SLIDER_CONTAINER.querySelector('.posts'), {
                        type: 'slider',
                        rewind: false,
                        startAt: 0,
                        perView: PER_VIEW,
                        gap: 30,
                        activeClass: 'activee',
                        bound: true,
                        breakpoints: {
                            950: {
                                perView: 2,
                            },
                            700: {
                                perView: 1,
                                focusAt: 0,
                                peek: {
                                    after: 60,
                                    before: 0
                                }
                            }
                        },
                    })

                    slider.update();

                    slider.mount();
                
                    if (SLIDES > PER_VIEW) {
                        if (SLIDER_CONTAINER.querySelector('.posts').getAttribute('per-view') === '2' && window.innerWidth > 950 && window.innerWidth < 2200) {
                            SLIDER_CONTAINER.querySelector('.glide__slide--active').nextElementSibling.nextElementSibling.classList.add('transparent'); 
                        } else if (SLIDER_CONTAINER.querySelector('.posts').getAttribute('per-view') === '3' && window.innerWidth > 950 && window.innerWidth < 2000) {
                            SLIDER_CONTAINER.querySelector('.glide__slide--active').nextElementSibling.nextElementSibling.nextElementSibling.classList.add('transparent'); 
                        }
                    }
                    
                    
                    slider.on('run.after', function(e){

                        const SLIDER_PER_VIEW = slider.selector.getAttribute('per-view');
                        
                        const ACTIVE_SLIDE = SLIDER_CONTAINER.querySelector('.glide__slide--active');
                        const ALL_SLIDES = SLIDER_CONTAINER.querySelectorAll('.glide__slide');
                        

                        for (let i = 0; i < ALL_SLIDES.length; i++) {
                            const SLIDE = ALL_SLIDES[i];
                            
                            if (SLIDES > PER_VIEW) {
                                if (SLIDER_CONTAINER.querySelector('.posts').getAttribute('per-view') === '2' && window.innerWidth > 950 && window.innerWidth < 2200) {
                                
                                    if (ACTIVE_SLIDE.previousElementSibling !== null && ACTIVE_SLIDE.nextElementSibling.nextElementSibling !== null) {
                                        SLIDE.classList.remove('transparent');
                                        ACTIVE_SLIDE.previousElementSibling.classList.add('transparent');
                                        ACTIVE_SLIDE.nextElementSibling.nextElementSibling.classList.add('transparent');
                                    } else if (ACTIVE_SLIDE.nextElementSibling.nextElementSibling === null) {
                                        SLIDE.classList.remove('transparent');
                                        ACTIVE_SLIDE.previousElementSibling.classList.add('transparent');
                                    } else if (ACTIVE_SLIDE.previousElementSibling === null) {
                                        SLIDE.classList.remove('transparent');
                                        ACTIVE_SLIDE.nextElementSibling.nextElementSibling.classList.add('transparent');
                                    }
                                } else if (SLIDER_CONTAINER.querySelector('.posts').getAttribute('per-view') === '3' && window.innerWidth > 950 && window.innerWidth < 2000) {    
                                    if (ACTIVE_SLIDE.previousElementSibling !== null && ACTIVE_SLIDE.nextElementSibling.nextElementSibling.nextElementSibling !== null) {
                                        SLIDE.classList.remove('transparent');
                                        ACTIVE_SLIDE.previousElementSibling.classList.add('transparent');
                                        ACTIVE_SLIDE.nextElementSibling.nextElementSibling.nextElementSibling.classList.add('transparent');
                                    } else if (ACTIVE_SLIDE.nextElementSibling.nextElementSibling.nextElementSibling === null) {
                                        SLIDE.classList.remove('transparent');
                                        ACTIVE_SLIDE.previousElementSibling.classList.add('transparent');
                                    } else if (ACTIVE_SLIDE.previousElementSibling === null) {
                                        SLIDE.classList.remove('transparent');
                                        ACTIVE_SLIDE.nextElementSibling.nextElementSibling.nextElementSibling.classList.add('transparent');
                                    }
                                } else {
                                    SLIDE.classList.remove('transparent');
                                }
                            }
                        }
                                    
                        if(slider.index === 0){
                            ARROW_LEFT.classList.add('disabled');
                            ARROW_RIGHT.classList.remove('disabled');
                        }else if(slider.index === (SLIDES - 2) && window.innerWidth > 580){
                            ARROW_LEFT.classList.remove('disabled');
                            ARROW_RIGHT.classList.add('disabled');
                        } else if (slider.index === (SLIDES - 1) && window.innerWidth <= 580) {
                            ARROW_LEFT.classList.remove('disabled');
                            ARROW_RIGHT.classList.add('disabled');
                        } else if(slider.index === (SLIDES - 3) && SLIDER_PER_VIEW === '3' && window.innerWidth > 580){
                            ARROW_LEFT.classList.remove('disabled');
                            ARROW_RIGHT.classList.add('disabled');
                        } else {
                            ARROW_LEFT.classList.remove('disabled');
                            ARROW_RIGHT.classList.remove('disabled');
                        }
                    });   

                    if (SLIDER_CONTAINER.querySelectorAll('.glide__slide').length > PER_VIEW) {
                        CONTROLS.style.display = 'flex';
                        
                        ARROW_LEFT.addEventListener('click', () => {
                            slider.go('<');
                        });

                        ARROW_RIGHT.addEventListener('click', () => {
                            slider.go('>');
                        });
                    }

                    if(SLIDER_CONTAINER.querySelectorAll('.glide__slide').length < PER_VIEW) { 
                        CONTROLS.style.display = 'none';
                    }

                }
            }
        }
    }
}
